export default __webpack_public_path__ + "static/blueprint-min-d01cc012c94ae596708e3fcb603493c3.png";